import React from 'react';
import PropTypes from 'prop-types';
import { createRefetchContainer, graphql } from 'react-relay';

import CrawlerTable from '@hydra/routes/crawler/components/CrawlerTable';
import BrokenHreflangIssuesRow from '../BrokenHreflangIssuesRow';

import { Translate } from '@hydra/common/components';
import FilterContainer from '@hydra/routes/crawler/components/FilterContainer';
import FilterString from '@hydra/routes/crawler/components/FilterString';
import { withFilters } from '@hydra/routes/crawler/components/withFilters';

export class BrokenHreflangIssuesTable extends React.Component {
  static propTypes = {
    project: PropTypes.shape({
      crawl: PropTypes.shape({
        canonicalCategory: PropTypes.shape({
          brokenHreflangs: PropTypes.shape({
            count: PropTypes.number,
            edges: PropTypes.arrayOf(
              PropTypes.shape({
                node: PropTypes.object
              })
            )
          })
        })
      })
    }).isRequired
  }

  render () {
    return (
      <>
        <FilterContainer>
          <FilterString
            onChange={this.props.onGraphQLInputChange('url')}
            value={this.props.filters.url}
            name='url'
            label={<Translate content='crawler_broken_hreflang_url' />}
          />
          <FilterString
            onChange={this.props.onGraphQLInputChange('sourceUrl')}
            value={this.props.filters.sourceUrl}
            name='sourceUrl'
            label={<Translate content='crawler_source_page_url' />}
          />
        </FilterContainer>
        <CrawlerTable {...this.props} category='canonicalCategory' section='brokenHreflangs'>
          <CrawlerTable.TableHead>
            <Translate content='crawler_broken_hreflang_url' size='6' />
            <Translate content='crawler_source_page_url' size='6' />
          </CrawlerTable.TableHead>
          <CrawlerTable.Body component={BrokenHreflangIssuesRow} />
        </CrawlerTable>
      </>
    );
  }
}
const WithFiltersTable = (withFilters)(BrokenHreflangIssuesTable);

export default createRefetchContainer(
  WithFiltersTable,
  {
    project: graphql`
      fragment BrokenHreflangIssuesTable_project on Project
      @argumentDefinitions(
        offset: {type: "Int", defaultValue: 0},
        limit: {type: "Int", defaultValue: 20},
        url: {type: "TextFilters", defaultValue: { operator: AND, values: [] }},
        sourceUrl: {type: "TextFilters", defaultValue: { operator: AND, values: [] }}
      ) {
        host,
        crawls (offset: 0, limit: 1) {
          edges {
            node {
              brokenHreflangs(offset: $offset, limit: $limit, url: $url, sourceUrl: $sourceUrl) {
                count
                edges {
                  node {
                    ...BrokenHreflangIssuesRow_issue
                  }
                }
              }
            }
          }
        }
      }
    `
  },
  graphql`
      query BrokenHreflangIssuesTable_RefetchQuery(
        $host: String!
        $limit: Int,
        $offset: Int,
        $sourceUrl: TextFilters,
        $url: TextFilters) {,
        project (host: $host) {
          ...BrokenHreflangIssuesTable_project @arguments(
            offset: $offset,
            limit: $limit,
            url: $url,
            sourceUrl: $sourceUrl
          )
        }
      }
    `
);
